var map = {
	"./beige_gold_principal.png": "8840",
	"./black_ceramic_watches.png": "5606",
	"./calf_principal.png": "1edc",
	"./diamond_principal.png": "655d",
	"./diamond_watch.png": "bf94",
	"./pink-gold.png": "4289",
	"./steel_principal.png": "7e6d",
	"./white_ceramic_watches.png": "731c",
	"./white_gold_principal.png": "3b96",
	"./yellow_gold_principal.png": "e556"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0d54";